import { LeaveTypesPanel } from '@/features/hr/components/LeaveSettings'

export default function HrLeavePolicyPage() {
  return <LeaveTypesPanel />
}
